import { render } from "./IntegrationsIndex.vue?vue&type=template&id=2ab976ce"
import script from "./IntegrationsIndex.vue?vue&type=script&lang=js"
export * from "./IntegrationsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__